import { Toast, Dialog } from 'vant';
import {nextTick, ref, Ref, watch, Watch, Vue} from "vue";
import wx from "jweixin-1.6.0";
import comment from "@/util/comment";

export default {

    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            answer: '',
            comment: {},
            answerUserId: this.$route.query.answerUserId,
            commentId: this.$route.query.commentId,
            answerCommentList: [],
            totalCommentAnswerLength: 0,
            defaultAvatar:  require('@/assets/cba/avatar.png'),
            commentIcon:  require('@/assets/vote_tips.png'),
            shareLogo: require('@/assets/cba/sharelogo.png'),
            page: 1,
            pageSize: 5,
            showPopUp: false,

            codeStr: '', //静默授权的code
            curOpenId: '', //微信openId
            accessToken: '',  //accessToken
            nickName: '',  //微信昵称
            headIngUrl: '',  //微信头像
            appId: '',
            timestamp: '',
            nonceStr: '',
            signature: '',
        };
    },
    methods: {
        onLoad () {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                this.$api.answerCommentList({
                    params: {
                        commentId: this.commentId,
                        'state': '1',
                        'page': this.page,
                        'pageSize': this.pageSize
                    },
                    success: function (res) {
                        if (res.code === 0 && Array.isArray(res.data)) {
                            this.answerCommentList.push(...res.data)
                            console.log(":::answerCommentList", res.data)
                            // 加载状态结束
                            this.loading = false;
                            this.page ++;
                        }

                    }.bind(this),
                })
                //数据全部加载完成
                if (this.answerCommentList.length >= this.totalCommentAnswerLength) {
                    this.finished = true;
                }
            }, 1000);
        },
        getShareInfo() {
            const textarea = document.createElement("textarea");
            textarea.value = window.location.href;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                const success = document.execCommand("copy");
                if(success){
                    Toast('链接复制成功，请在微信客户端中打开链接');
                }else{
                    Toast.fail('链接复制失败', err);
                }
            } catch (err) {
                Toast.fail('链接复制失败', err);
            }
            document.body.removeChild(textarea);
            // navigator.clipboard.writeText(window.location.href).then(() =>{
            //     Dialog.alert({
            //         message: '链接复制成功，请在微信客户端中打开链接',
            //         theme: 'round-button',
            //     }).then(() => {
            //         // on close
            //     });
            // }, (err) => {
            //     Toast.fail('链接复制失败', err);
            // });
            //获取url链接（如果有#需要这么获取）
            //let url = encodeURIComponent(window.location.href.split("#")[0]);
            //获取url链接（如果没有#需要这么获取）
            //console.log("url：", location.href.replace(location.hash, ''));
            //let url = encodeURIComponent(window.location.href);
            //let url = 'http://acui.danyang.com/dycbaCommentList';
            //console.log("encodeURIComponenturl：", window.location.href.split('#')[0]);
            // this.$api.getSing({
            //     params: {
            //         url: window.location.href.split('#')[0],
            //     },
            //     success: function (res) {
            //         console.log("res：", res);
            //         wx.config({
            //             debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            //             appId: res.data.appId, // 必填，公众号的唯一标识
            //             timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            //             nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            //             signature: res.data.signature, // 必填，签名
            //             jsApiList: [
            //                 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline',
            //                 'onMenuShareQQ', 'onMenuShareQZone'
            //             ] // 必填，需要使用的 JS 接口列表
            //         });
            //         wx.ready(function() { //需在用户可能点击分享按钮前就先调用
            //             // 注册分享朋友事件
            //             // wx.updateTimelineShareData({
            //             //     title: '我的丹阳APP宣传标语投票', // 分享标题
            //             //     desc: '我的丹阳',
            //             //     link: window.location.href.split('#')[0], // 分享链接，该链接域名必须与当前企业的可信域名一致
            //             //     imgUrl: 'http://ws.danyang.com/mydy/img/mydyLogo.png', // 分享图标
            //             //     success: function() {
            //             //         // alert('朋友圈分享成功');
            //             //     }
            //             // });
            //             wx.updateAppMessageShareData({
            //                 title: '我的丹阳APP宣传标语投票', // 分享标题
            //                 desc: '我的丹阳', // 分享描述
            //                 link: location.href.replace(location.hash, ''),
            //                 imgUrl: 'http://ws.danyang.com/mydy/img/mydyLogo.png', // 分享图标
            //                 success: function() {
            //                     // alert('朋友分享成功');
            //                 }
            //             });
            //             console.log("link：", window.location.href.split('#')[0]);
            //             // wx.onMenuShareAppMessage({
            //             //     title: '我的丹阳APP宣传标语投票', // 分享标题
            //             //     desc: '我的丹阳', // 分享描述
            //             //     link: 'http://acui.danyang.com/dycbaCommentList',
            //             //     imgUrl: 'http://ws.danyang.com/mydy/img/mydyLogo.png', // 分享图标
            //             //     success: function() {
            //             //         // alert('朋友分享成功');
            //             //     }
            //             // });
            //             // wx.onMenuShareTimeline({
            //             //     title: '我的丹阳APP宣传标语投票', // 分享标题
            //             //     desc: '我的丹阳', // 分享描述
            //             //     link: 'http://acui.danyang.com/dycbaCommentList',
            //             //     imgUrl: 'http://ws.danyang.com/mydy/img/mydyLogo.png', // 分享图标
            //             //     success: function() {
            //             //         // alert('朋友分享成功');
            //             //     }
            //             // });
            //         });
            //         // wx.checkJsApi({
            //         //     jsApiList: [
            //         //         'updateAppMessageShareData', 'updateTimelineShareData'
            //         //     ],
            //         //     success: function (res) {
            //         //         //alert(res.errMsg);
            //         //     }
            //         // });
            //         //错误了会走 这里
            //         wx.error(function (res) {
            //             console.log("微信分享错误信息", res);
            //         });
            //     }
            // })
        },
        answerComment: function () {
            if(this.answer !== '' && this.answerUserId !== undefined) {
                console.log(":::answerUserId", this.answerUserId)
                this.$api.answerComment({
                    params: {
                        commentId: this.commentId,
                        answerUserId: this.answerUserId,
                        answer: this.answer,
                    },
                    success: function (res) {
                        console.log(":::success", res)
                        Toast('回复审核中');
                        this.answer = '';
                    }.bind(this),
                    fail: function (res) {
                        console.log(":::fail", res)
                        Toast('回复失败');
                    }
                })
            }else if(this.answer === ''){
                Toast('请先输入回复');
            }else if(this.answerUserId === undefined){
                Toast('请在我的丹阳客户端中进行评论');
            }
        }
    },
    mounted() {
        this.codeStr = comment.GetQueryString("code");
        if (this.codeStr != null && this.codeStr != "") {
            this.getAccessTokenByCode(); //静默授权获取openId
        }
        this.$api.getTotalAnswerCommentList({
            params: {
                'state': '1',
                commentId: this.commentId,
            },
            success: function (res) {
                this.totalCommentAnswerLength = res.data.count;
                this.comment = res.data.comment;
                console.log(":::comment:",this.comment)
            }.bind(this)
        })
    }
};
